import styled from '@emotion/styled';
import Page from '../../layout/Page';

const Subscribe:React.FC<any> = () => {
  const handleAddtofriend = () => {
    window.location.href='http://pf.kakao.com/_eiGQK/friend'
  }
  return(
    <>
    <Page disable>
      <Container>
        <ImgContainer>
          <Img src="/images/newLanding/event/event_2.png"/>
        </ImgContainer>
        <TextContainer>
          <Title className="top">배송비만 내고 인화구독 체험하기!!</Title>
          <SmallText>
            포티페타에서 <span>7월</span> 한달간, 특별한 혜택을 준비 했습니다. 
            <br />카카오톡 채널 추가만 하면 배송비만 추가로 부담하고, 
            <br />소중한 사진 10장을 무료로 인화해 드립니다.
            <br />
            <br /> 1. 카카오톡 친구 추가를 한다.
            <br /> 2. 고객 센터로 인화하고 싶은 사진 10장을 보낸다.
            <br /> 3. 채팅창에 제공된 링크를 타고 <span>배송비!</span>만 결제를 한다.
            <br /> 4. 신청 완료! 인화된 사진 10장이 집으로 배송됩니다
            <br />
            <br /> 지금 바로 신청하여 소중한 추억을 간직하세요. 친구들에게도 이 특별한 혜택을 알려주세요!
          </SmallText>
        </TextContainer>
        <CircularButtonWrapper
        onClick={handleAddtofriend}
      >
        <CircularButton>
          카카오톡 채널 추가 하러 가기
        </CircularButton>
      </CircularButtonWrapper>
      </Container>
    </Page>
    </>
  )
}

export default Subscribe;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
  background-color: #fcf7ef;
`;

const ImgContainer = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  &.top{
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 40px auto 0px;
  }

  &.bottom {
    margin: 50px 20px 30px;
  }
`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px;
  line-height: 2;

  span {
    font-weight: bold;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CircularButtonWrapper = styled.div`
  display: flex;
  margin: 0px auto 70px;
  width: 70%;
  height: 55px;
`;

const CircularButton = styled.button`
  width: 100%;
  border-radius: 30px;
  /* background-color: #e1a349; */
  background-color: black;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
`;


